<template>
  <el-button
    v-bind="$attrs"
    :size="size"
    :title="title"
    :class="['bdc-table-download-btn', customClass, { 'bdc-log-download': primary }]"
    v-on="$listeners"
  >
    <svg-icon icon-class="bdc-btn-download" class="bdc-table-download-btn__icon" />
  </el-button>
</template>

<script>
export default {
  name: 'BdcDownloadButton',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'small'
    },
    title: {
      type: String,
      default: '下载'
    },
    primary: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
